import { get, post } from '../http';


class SmartPayApi {

    static get_smart_pay_link = (url, queryData) => {
        return get(url, queryData);
    }

    static proceed_to_save_payment_details = (url, queryData) => {
        let endpoint = url + "/save_payment_details/";
        return post(endpoint, queryData)
    }

    static update_smart_pay_link = (url, queryData) => {
        let endpont = url + "/update_payment_details/";
        return post(endpont, queryData)
    }
}

export default SmartPayApi;